<template>
    <div class="cmp_mobile--header" ref="cmpMobile" id="cmpMobile">
        <div :class="isScroll || alwaysShow ? 'mobile_header--inner black' : 'mobile_header--inner'">
            <img :src="require('../assets/images/logo.png')" alt="MediaGo" class="header-logo">
            <i :class="!showSideBar ? 'cmp-icon-mobile-menu' : 'cmp-icon-mobile-close'" @click="handleClick"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cmp_mobile--header',
    props: {
        showSideBar: {
            type: Boolean,
            default: () => false
        },
        alwaysShow: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            showMenu: false,
            isScroll: false,
            startPointY: undefined,
            moveY: undefined
        };
    },
    components: {},
    watch: {
        showSideBar: {
            handler(val) {
                this.showMenu = val;
            },
            immediate: true
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, true);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleClick() {
            this.showMenu = !this.showMenu;
            this.$emit('openSideBar', this.showMenu);
        },
        handleScroll(e) {
            // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            // let headHeight = this.$refs.cmpMobile.clientHeight;
            let dom = window.document.getElementById('cmpMobile');
            let bodyDom = window.document.getElementsByClassName('cmpMobilePage');
            if (dom && bodyDom) {
                let headHeight = dom.clientHeight;
                let top = bodyDom[0].getBoundingClientRect().top * (-1);
                // console.log(headHeight, top);
                this.isScroll = top > headHeight;
            }
        }
    }
};
</script>

<style lang="scss">
.cmp_mobile--header {
    width: 100%;
    height: mvw(50);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    // transform: translateZ(0);
    .mobile_header--inner {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: mvw(12) mvw(15);
        height: mvw(50);
        box-sizing: border-box;
        .header-logo {
            width: mvw(125);
            height: mvw(26);
        }
        .cmp-icon-mobile-menu {
            width: mvw(20);
            height: mvw(14);
        }
        .cmp-icon-mobile-close {
            width: mvw(16);
            height: mvw(16);
        }
    }
    .black {
        background: #000;
        animation: fade .5s;
    }
    @keyframes fade {
        from {
            opacity: 0.5;
        }
        to {
            opacity: 1;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/modules/mobile/components/header.vue